import React from "react";
import PropTypes from "prop-types";
import Button from "@paprika/button";
import GraphExamine from "@acl-services/wasabicons/lib/GraphExamine";
import "./storyboardDrilldownButton.scss";

const propTypes = {
  onDrilldownClick: PropTypes.func,
  onMouseEnterDrilldown: PropTypes.func,
  onMouseLeaveDrilldown: PropTypes.func,
  presentationMode: PropTypes.bool,
  isDrilldown: PropTypes.bool,
};

const defaultProps = {
  onDrilldownClick: () => {},
  onMouseEnterDrilldown: () => {},
  onMouseLeaveDrilldown: () => {},
  presentationMode: false,
  isDrilldown: false,
};

export default function StoryBoardDrilldownButton(props) {
  const {
    onDrilldownClick,
    onMouseEnterDrilldown,
    onMouseLeaveDrilldown,
    presentationMode,
    isDrilldown,
  } = props;

  // SIMPLIFIED: Trust parent's isDrilldown decision
  // The parent component (StoryboardBoard.jsx) handles:
  // - editMode logic
  // - access control logic  
  // - feature flag logic
  // This child component just needs to respect those decisions
  
  // Hide in presentation mode (this is component-level behavior)
  if (presentationMode) {
    return null;
  }
  
  // Trust parent's isDrilldown calculation
  if (!isDrilldown) {
    return null;
  }

  // FIXED: Use the SAME structure that works from Angular path
  return (
    <div
      className="storyboard-drilldown-button"
      aria-label="drilldown-container"
      data-testid="_storyboard-drilldown__button"
    >
      <Button.Icon
        aria-label="drilldown-button"
        kind="primary"
        onClick={() => onDrilldownClick()}
        onMouseEnter={onMouseEnterDrilldown}
        onMouseLeave={onMouseLeaveDrilldown}
      >
        <GraphExamine />
      </Button.Icon>
    </div>
  );
}
StoryBoardDrilldownButton.propTypes = propTypes;
StoryBoardDrilldownButton.defaultProps = defaultProps;
StoryBoardDrilldownButton.displayName = "StoryBoardDrilldownButton";